import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { StripePaymentIntentStatus } from '@/modules/billing/constants/StripePaymentIntentStatus';

export class StripePaymentIntent extends BaseModel {
  public id: string;

  public clientSecret: string;

  public amount: number;

  public confirmationMethod: string;

  public currency: string;

  public customer: string;

  /**
   * I'm not sure what this is supposed to contain
   */
  public metadata: Record<string, unknown>;

  public receiptUrl: string;

  public creditCardLastFourDigits: string;

  public status: StripePaymentIntentStatus;

  constructor(model: Partial<StripePaymentIntent> = {}) {
    super();

    this.id = model.id as string;
    this.clientSecret = model.clientSecret as string;
    this.amount = model.amount as number;
    this.confirmationMethod = model.confirmationMethod as string;
    this.currency = model.currency as string;
    this.customer = model.customer as string;
    this.metadata = model.metadata as Record<string, unknown>;
    this.receiptUrl = model.receiptUrl as string;
    this.creditCardLastFourDigits = model.creditCardLastFourDigits as string;
    this.status = model.status as StripePaymentIntentStatus;
  }
}
